import{s as e}from"../../../../use-sync-external-store/shim/index.js";const s=e.useSyncExternalStore;export{s as useSyncExternalStore};
